"use client";

import React from "react";
import Heading from "@/components/molecules/Heading";
import { CardHighlight, CardArticle } from "@ama-pt/agora-design-system";

import { NewsBlockProps } from "@/page-builder/fragments/NewsBlock/types";
import { MappedNewsItem } from "@/services/new/types";
import BupiLink from "@/components/atoms/link";
import { useTranslations } from "next-intl";

type NewsListProps = {
  newsData: NewsBlockProps | null;
  newsItems: MappedNewsItem[];
};

export default function NewsBlock({ newsData, newsItems }: NewsListProps) {
  const t = useTranslations("homepage");
  if (!newsData) {
    return null;
  }
  const highlight = newsData.featured ?? newsItems[0];

  if (!highlight) {
    return null;
  }

  const articles = newsData.featured ? newsItems : newsItems.slice(1);

  return (
    <section className="container mx-auto">
      <div className="">
        <Heading
          title={newsData.title}
          description={newsData.description}
        />
      </div>

      <div className="py-64">
        <CardHighlight
          cardPosition="middle"
          highlightAreaPosition="interior"
          title={highlight.title}
          subtitle={
            <span className="text-primary-500 font-semibold">
              {Array.isArray(highlight.categories)
                ? highlight.categories.map((cat) => cat.name).join(", ")
                : highlight.categories?.name}
            </span>
          }
          image={{
            src:
              (highlight?.featuredImage && highlight.featuredImage.url) || "",
            alt: highlight.featuredImage?.alt || highlight.title,
          }}
          description={highlight.description}
          links={[
            {
              children: (
                <span className="text-primary-500 font-semibold">
                  {t("readMore")}
                </span>
              ),
              href: "noticia/" + highlight?.slug || "",
              hasIcon: true,
            },
          ]}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-32">
        {articles.map((item: MappedNewsItem, index) => (
          <CardArticle
            key={index}
            title={item.title}
            variant="default"
            subtitle={
              <span className="text-primary-500 font-semibold">
                {Array.isArray(item.categories)
                ? item.categories.map((cat) => cat.name).join(", ")
                : item.categories}
              </span>
            }
            blockedLink
             className={
    !item.featuredImage?.url
      ? "[&_.card-image]:!object-contain [&_.card-image]:p-24"
      : undefined
  }
            image={
              item.featuredImage.url
                ? {
                    src: item.featuredImage.url,
                    alt: item.featuredImage.alt || item.title,
                  }
                : {
                  src: "/bupilogo.svg",
                  alt: item.title,
                }
            }
            mainAnchor={{
              children: "Open link",
              href: "noticia/" + item?.slug || "",
              iconOnly: true,
              hasIcon: true,
              "aria-label": "Ler Mais sobre " + item.title,
            }}
          >
            <div className="mt-16 text-m-regular text-neutral-800">
              <p> {item.description} </p>
            </div>
          </CardArticle>
        ))}
      </div>

      {newsData.label && (
        <div className="mt-64 ">
          <BupiLink
            key={newsData.label}
            label={newsData.label}
            url={newsData.url}
            target={newsData.target}
            hasIcon
            className="inline-flex items-center gap-8 text-primary-500 font-semibold text-lg"
          />
          
        </div>
      )}
    </section>
  );
}
